<div class="d-flex flex-column align-items-center reauth-container">
    <div class="w-100 px-4 py-4">
        <div class="mx-auto w-100 reauth-box">
            <!-- Title -->
            <div class="text-center d-flex align-items-center justify-content-center gap-2 title">
                Still There?
            </div>

            <div class="text-center detail">
                <p>
                    We paused your session due to inactivity. Please enter your password to resume.
                </p>
            </div>


            <!-- Re-authentication form -->
            <form class="mt-4" *ngIf="reAuthForm" [formGroup]="reAuthForm" #reAuthNgForm="ngForm">
                <!-- Password field only -->
                <div class="form-input">
                    <mat-form-field appearance="outline" class="w-100">

                        <mat-label>Password</mat-label>
                        <input matInput id="password" matInput type="password" [formControlName]="'password'"
                            #passwordField />
                        <button mat-icon-button type="button" (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        " matSuffix>
                            @if (passwordField.type === 'password') {
                            <mat-icon matSuffix> visibility_off</mat-icon>
                            }
                            @if (passwordField.type === 'text') {
                            <mat-icon matSuffix> visibility</mat-icon>
                            }
                        </button>
                        <mat-error> Password is required </mat-error>
                    </mat-form-field>

                </div>

                <!-- Submit button -->
                <button type="button" class="btn btn-dark mt-3 w-100 reauth-btn" [disabled]="reAuthForm.disabled"
                    (click)="reAuthenticate()">
                    @if (!reAuthForm.disabled) {
                    <span>Re-authenticate</span>
                    }
                    @if (reAuthForm.disabled) {
                    <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
                    }
                </button>
            </form>
        </div>
    </div>
</div>